<template>
<div v-if="errors && errors.length">
    <small v-for="error in errors" :key="error" class="text-danger">
        {{ error }}
    </small>
</div>
</template>

<script>
export default {
    props: {
        errors: {
            type: Array,
            required: false,
            default() {
                return []
            }
        }
    },
    data() {
        return {}
    },
    computed: {},
    async mounted() {},
    methods: {}
}
</script>

<style lang="scss" scoped></style>


